// extracted by mini-css-extract-plugin
export default {"Paper":"SportMedicineEducation_Paper__+2wwK","Alert":"SportMedicineEducation_Alert__UhnYl","Button":"SportMedicineEducation_Button__QCBGe"};